import iBS02IR_ResultType from '../model/iBS02IR_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: iBS02IR_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "battery", "event", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_iBS02IR_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_iBS02IR_Result;
